var _g, _g2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 506.4 506.4",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 253.2,
    cy: 253.2,
    r: 249.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M253.2,219.2L253.2,219.2L156,316.4c-3.6,3.6-9.6,3.6-13.2,0l-9.2-9.2c-3.6-3.6-3.6-9.6,0-13.2 l113.2-113.2c2-2,4.4-2.8,6.8-2.8c2.4,0,4.8,0.8,6.8,2.8L373.6,294c3.6,3.6,3.6,9.6,0,13.2l-9.2,9.2c-3.6,3.6-9.6,3.6-13.2,0 L253.2,219.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.6,323.2c-3.6,0-6.8-1.2-9.6-4l-94.4-94.4l-94.4,94.4c-5.2,5.2-14,5.2-18.8,0l-9.2-9.2c-2.4-2.4-4-6-4-9.6 s1.2-6.8,4-9.6l113.2-113.2c2.4-2.4,6-4,9.6-4s6.8,1.2,9.6,4l113.2,113.2c5.2,5.2,5.2,13.6,0,18.8l-9.2,9.2 C364.4,322,360.8,323.2,357.6,323.2z M253.2,215.2L253.2,215.2c1.2,0,2,0.4,2.8,1.2l97.6,97.6c2,2,5.6,2,7.6,0l9.2-9.2 c2-2,2-5.6,0-7.6L257.2,184c-1.2-1.2-2.4-1.6-4-1.6s-2.8,0.4-4,1.6L136,297.2c-1.2,1.2-1.6,2.4-1.6,4s0.4,2.8,1.6,4l9.2,9.2 c2,2,5.6,2,7.6,0l97.2-97.2C251.2,215.6,252.4,215.2,253.2,215.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.2,506.4C113.6,506.4,0,392.8,0,253.2S113.6,0,253.2,0s253.2,113.6,253.2,253.2S392.8,506.4,253.2,506.4z M253.2,8 C118,8,8,118,8,253.2s110,245.2,245.2,245.2s245.2-110,245.2-245.2S388.4,8,253.2,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.79020f219067b00fda20083b2e429240.svg";
export { ForwardRef as ReactComponent };